import React, { useContext } from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ProjectContext } from '../../../contexts/ProjectContext';
import EditProjectStepModal from './EditProjectStepModal';
import CompanyList from '../Company/CompanyList';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: '40px 0',
  },
  allCompanies: {
    padding: 16,
    backgroundColor: '#f9f9f9',
    text: theme.palette.secondary.dark,
    fontWeight: 600,
  },
}));

const ProjectScopeOfOffering: React.FC = () => {
  const classes = useStyles();
  const { project, hideTraderFields } = useContext(ProjectContext);

  if (hideTraderFields) {
    return null;
  }

  return (
    <>
      <Divider className={classes.divider} />
      <Grid item container direction="row" justifyContent="space-between">
        <Typography variant="h3" color="textPrimary" gutterBottom>
          Scope of Offering
        </Typography>
        <EditProjectStepModal
          step="ASSIGN"
          maxWidth="lg"
          width={1000}
          height={750}
        />
      </Grid>
      <Grid container direction="row" style={{ marginTop: 8 }}>
        {project.individualScope ? (
          <Grid item xs={12}>
            <Typography align="center" className={classes.allCompanies}>
              This Project is available to all mobile users
            </Typography>
          </Grid>
        ) : (
          <CompanyList
            companyIds={project.companies}
            allCompaniesContent={
              <Grid item xs={12}>
                <Typography align="center" className={classes.allCompanies}>
                  This Project is available to all clients
                </Typography>
              </Grid>
            }
          />
        )}
      </Grid>
    </>
  );
};

export default ProjectScopeOfOffering;
